import { z } from 'zod';

export interface ProtagAnimal {
    id: string;

    createdAt: Date;
    updatedAt: Date;

    name: string;
}

export const protagAnimalSchema = z.object({
    id: z.string().uuid(),

    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),
});

export const mockProtagAnimal = ({
    id = '456ee3eb-226c-4abb-9b9f-424e4e5f2ef3',

    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock protag',
}: Partial<ProtagAnimal> = {}): ProtagAnimal => ({
    id,

    createdAt,
    updatedAt,

    name,
});
